import { useMemo } from "react";
import { useNameColumn } from "./useNameColumn";
import { useEmployeeNumberColumn } from "./useEmployeeNumberColumn";
import { useGroupColumns } from "./useGroupColumns";
import { useLocationsColumn } from "./useLocationsColumn";
import { useJobsColumn } from "./useJobsColumn";
import { usePaymentColumn } from "./usePaymentColumn";
import { useActionsColumn } from "./useActionsColumn";
import { usePayGroupColumn } from "./usePayGroupColumn";
import { useEarningGroupsColumns } from "./useEarningGroupsColumns";

import { usePreferences } from "../../../../Settings/Configuration/hooks/usePreferences";

export const useColumns = ({ viewSummary, viewProfile, canViewRates }) => {
  const hideDailySummary = usePreferences(
    "timeSheetWeekly.hideDailySummary"
  );

  const nameColumn = useNameColumn({ viewProfile });
  const employeeNumberColumn = useEmployeeNumberColumn();
  const payGroupColumn = usePayGroupColumn();
  const groupColumns = useGroupColumns();
  const locationsColumn = useLocationsColumn();
  const jobsColumn = useJobsColumn();
  const earningGroupsColumns = useEarningGroupsColumns();

  const paymentColumn = usePaymentColumn();
  const actionsColumn = useActionsColumn({ viewSummary });

  return useMemo(() => {
    const columns = [
      nameColumn,
      employeeNumberColumn,
      payGroupColumn,
      ...groupColumns,
      locationsColumn,
      jobsColumn,
      ...earningGroupsColumns,
    ];

    if (canViewRates) {
      columns.push(paymentColumn);
    }

    if (hideDailySummary) {
      columns.push(actionsColumn);
    }

    return columns;
  }, [
    nameColumn,
    employeeNumberColumn,
    payGroupColumn,
    groupColumns,
    locationsColumn,
    jobsColumn,
    earningGroupsColumns,
    paymentColumn,
    actionsColumn,
    hideDailySummary,
    canViewRates,
  ]);
};
